import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { getAllUnloadingWaitTimeReport, getAllUnloadingReport } from "../../../Apis/TrafficMarshalReports/ReportsTrafficMarshal";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../../Common/ShimmerLoader";
import ExcelJS from "exceljs";
import vehicle from "../../AssetVehicle/vehicle";
import isGHMC from "../../../Common/helper/helpar";
import { AllVehicleTypeDetails } from '../../../Apis/vehicleApi';
import { AllOwnerTypeDetails } from '../../../Apis/ownerTypeApi';
import CreatableSelect from 'react-select/creatable';
const UnloadingWaitTime = ({ t }) => {
  const headers = [
    "vehicleNo",
    // "TSName",
    "vehicleType",
    "ownerType",
    "containerCode",
    "WeighbridgeInTime",
    "UnloadingInTime",
    "UnloadingWaitTime",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [data, setData] = useState([]);
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);
  const isProd = isGHMC();



  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };
    console.log(selectedOwnerType, 'selectedowner')
    fetchOwnerTypeData();
  }, [selectedOwnerType]);

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);




  // Function to calculate totals (including time-based fields)
  // Function to calculate totals (sum of all UnloadingWaitTime counts)
  const calculateTotals = (data) => {
    return data.reduce(
      (totals, row) => {
        // Convert UnloadingWaitTime to a number and add it to the total count
        const waitTime = parseInt(row.UnloadingWaitTime, 10) || 0;
        totals.UnloadingWaitTimeCount += waitTime;
        return totals;
      },
      {
        UnloadingWaitTimeCount: 0, // Initialize count
      }
    );
  };

  // Add a total row with the sum of UnloadingWaitTime
  const addTotalRow = (data) => {
    if (!data.length) return data;

    const totals = calculateTotals(data);
    console.log(totals);

    return [
      ...data,
      {
        UnloadingInTime: "Total",
        UnloadingWaitTime: totals.UnloadingWaitTimeCount, // Show total count
      },
    ];
  };



  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedOwnerType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedOwnerType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedOwnerType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };
  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };




  useEffect(() => {
    setOptionsValues(ownerTypeDetails
      .filter((ownerType) => ownerType.isActive)
      .map(ownerType => ({
        value: ownerType.ownerTypeId,
        label: ownerType.ownerTypeName,
      })));
  }, [ownerTypeDetails]);

  useEffect(() => {
    setVehicleTypeOptionsValues(vehicleTypeDetails.map(vehicleType => ({
      value: vehicleType.vehicleTypeId,
      label: vehicleType.vehicleTypeName,
    })));
  }, [vehicleTypeDetails]);
  useEffect(() => {
    // const currentDate = new Date().toISOString();
    fetchTripsTonnageData(startDate, endDate, selectedVehicleType, selectedOwnerType);
  }, []);

  const fetchTripsTonnageData = async (startDate, endDate, selectedVehicleType, selectedOwnerType) => {
    try {
      setIsLoading(true);
      const requestData = {
        FromDate: startDate,
        ToDate: endDate,
        ownerType: selectedOwnerType,  // Ensure these keys match
        vehicleType: selectedVehicleType
      };

      console.log(requestData, requestData)
      const response = await getAllUnloadingReport(requestData);
      console.log(response, 'apiresponse')


      let formattedData = response.data.map((item) => ({
        ...item,
        vehicleNo: item.vehicleNumber || "N/A",
        vehicleType: item.vehicleTypeName || "N/A",
        ownerType: item.ownerTypeName || "N/A",
        // TSName: item.transferStationName,
        containerCode: item.containerCode || "N/A",
        WeighbridgeInTime: item.weighingInTime || "N/A",
        UnloadingInTime: item.trafficMarshalUnloadingInTime || "N/A",
        UnloadingWaitTime: item.operationDuration || "N/A"
      }));
      if (vehicleNumber) {
        formattedData = formattedData.filter(item => item.vehicleNo.includes(vehicleNumber));
      }
      console.log('Filtered Data:', formattedData);
      setData(addTotalRow(formattedData));
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };


  const handleFormSubmit = (e) => {
    e.preventDefault();
    const currentDate = new Date().toISOString();
    const fromDate = startDate || currentDate;
    const toDate = endDate || currentDate;
    fetchTripsTonnageData(startDate, endDate, selectedVehicleType || '', selectedOwnerType || '');

  };




  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Vehicle Unloading Wait Time Reports`;
    const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("VehicleUnloadingWaitTimeReports");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 7); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Unloading Wait Time Report", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 7); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Unloading Wait Time Report"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }



    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle No",
      "Vehicle Type",
      "Owner Type",
      // "TSName",
      "Container Code",
      "Weighbridge In Time",
      "Unloading In Time",
      "Unloading Wait Time",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 9) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    data.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.vehicleNumber?? "N/A",
        item.vehicleTypeName?? "N/A",
        item.ownerTypeName?? "N/A",
        // TSName: item.transferStationName,
        item.containerCode?? "N/A",
        item.weighingInTime?? "N/A",
        item.UnloadingInTime?? "N/A",
        item.UnloadingWaitTime?? "N/A"
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 9) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "VehicleUnloadingWaitTimeReports.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };



  return (
    <>
      {isLoading ? ( // Check isLoading state and show loader if true
        <TableLoader height={500} />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 class="text-start mb-3"> Unloading Wait Time Report</h4>
              <div className="card">
                <div className="card-body p-3">
                  <form onSubmit={handleFormSubmit}>
                    <div className="row align-items-end g-3" style={{ textAlign: "left" }}>
                      <div className="col-md-2">
                        <label>From Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="FromDate"
                          style={inputStyle}
                          className="form-control"
                          value={startDate}
                          max={endDate ? endDate : getCurrentDateTime()}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label>To Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="ToDate"
                          style={inputStyle}
                          value={endDate}
                          className="form-control"
                          min={startDate}
                          max={getCurrentDateTime()}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label htmlFor="ownerType">Owner Type:</label>
                        <CreatableSelect
                          classNamePrefix="CreatableSelect"
                          inputId="ownerType"
                          name="ownerTypeId"
                          id="ownerType"
                          placeholder="Select"
                          options={optionsValues}
                          isClearable={true}
                          onChange={handleChange}
                          onCreateOption={(inputValue) => {
                            const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                            if (inputValue) {
                              setSelectedOwnerType(newValue.value);
                              setOptionsValues((prevOptions) => [...prevOptions, newValue]);
                            } else {
                              setSelectedOwnerType("");
                            }
                          }}
                          value={optionsValues.find((option) => option.value === selectedOwnerType)}
                        //  className="hidden-select" // Apply the custom class here
                        />
                      </div>
                      <div className="col-md-2">
                        <label htmlFor="VehicleType">Vehicle Type:</label>
                        <CreatableSelect style={{ Height: '34px !important' }}
                          classNamePrefix="CreatableSelect"
                          inputId="vehicleType"
                          name="vehicleTypeId"
                          id="vehicleType"
                          placeholder="Select"
                          options={vehicleTypeOptionsValues}
                          isClearable={true}
                          onChange={handleVehicleTypeChange}
                          onCreateOption={(inputValue) => {

                            const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                            { inputValue && newValue ? (setSelectedVehicleType(newValue.value)) : setSelectedVehicleType("  "); }
                            // setSelectedOwnerType(newValue.value);
                            // Add logic to update optionsValues with the new option if needed
                          }}
                          value={vehicleTypeOptionsValues.find((option) => option.value === selectedVehicleType)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label>Vehicle Number</label>
                        <input
                          type="text"
                          name="vehicleTypeCode"
                          style={inputStyle}
                          placeholder="Vehicle Number"
                          value={vehicleNumber}
                          onChange={(e) => setVehicleNumber(e.target.value)}
                        />
                      </div>

                      <div className="col-md-2 d-flex justify-content-between">
                        <button
                          type="submit"
                          className={`btn  ${isProd ? "search-ghmc" : "search-swm"}`}

                        >
                          Search
                        </button>
                        <button
                          className="btn btn-excel"
                          onClick={downloadAsExcel}
                        >
                          <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                        </button>
                      </div>
                    </div>
                  </form>
                  <div className="mt-3">
                    {/* <div className="top-header">
                  <span>{t("Primary Deployment Transaction Report")} </span>
                </div> */}
                    <TableComponent isLoading={isLoading}
                      hasTotalRow
                      DataFetchURL={data}
                      headers={headers}
                      filterFunction={(data) =>
                        data.filter(
                          (item) => item.status === 1 || item.status === 2
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      )}
    </>
  );
};

// Rest of the component remains the same

export default withTranslation()(UnloadingWaitTime);

// Styles for input and button
const inputStyle = {
  height: "38px",
  borderRadius: "4px",
  border: "1px solid #ced4da",
  paddingLeft: "10px",
  width: "100%",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  marginTop: "29px",
  borderRadius: "5px",
  color: "#fff",
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
